import { render, staticRenderFns } from "./QuestionEditTabInformation.vue?vue&type=template&id=71a8250a&scoped=true&"
import script from "./QuestionEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./QuestionEditTabInformation.vue?vue&type=script&lang=js&"
import style0 from "./QuestionEditTabInformation.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./QuestionEditTabInformation.vue?vue&type=style&index=1&id=71a8250a&scoped=true&lang=css&"
import style2 from "./QuestionEditTabInformation.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a8250a",
  null
  
)

export default component.exports